import { FormTemplateFieldConditionalRule } from 'mapistry-shared';
import { useMemo } from 'react';
import { useFormState } from 'react-final-form';

const isEmptyRule = (rule: FormTemplateFieldConditionalRule): boolean =>
  !rule.operator &&
  !rule.conditionalFieldValues?.length &&
  !rule.conditionallyShownFields.some((field) => field.id);

export const isEmptyState = (
  conditionalRules: FormTemplateFieldConditionalRule[],
): boolean => {
  const emptyRules = conditionalRules.filter((rule) => isEmptyRule(rule));
  return conditionalRules.length === 1 && emptyRules.length === 1;
};

export function useIsEmptyState(): boolean {
  const {
    values: { conditionalRules },
  } = useFormState<{
    conditionalRules: FormTemplateFieldConditionalRule[];
  }>();

  return useMemo(() => isEmptyState(conditionalRules), [conditionalRules]);
}
